import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { COLOR_CODES } from "../../common";
import { DynamicDatePicker } from "../../components/DatePicker";
import { ReactComponent as Logo } from "../../icons/gnai_logo.svg";
import { ReactComponent as LogOutIcon } from "../../icons/logout.svg";
import { setLoggedIn } from "../Protected";
import { getLatestDataPriceForecastDate } from "../../Rest_api/RestApi";
import "./mobile-responsive.css";

const TABS_GROUP = [
  {
    "headline": "Derivative",
    "tabs": ["Market Analysis", "Options Analysis"]
  },
];

interface MarketDerivativeHeaderProps {
  dates: {
    startDate: Date;
    endDate: Date;
    key: string;
  };
  setDates: (dates: {
    startDate: Date;
    endDate: Date;
    key: string;
  }) => void;
  tab: string;
  setTab: (tab: string) => void;
}

export function MarketDerivativeHeader({ dates, setDates, tab, setTab }: MarketDerivativeHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [maxDate, setMaxDate] = useState<string>(
    new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]
  );

  useEffect(() => {
    // Set the initial tab based on the URL
    const tabFromUrl = new URLSearchParams(location.search).get("tab") as any;
    if (TABS_GROUP.flatMap((value) => value.tabs).includes(tabFromUrl)) {
      setTab(tabFromUrl);
    }
  }, []);

  useEffect(() => {
    // Update the URL whenever the tab changes
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    navigate({ search: params.toString() }, { replace: true });
  }, [tab]);

  useEffect(() => {
    // Fetch the latest date from DataPriceForecast
    const fetchLatestDate = async () => {
      try {
        const response = await getLatestDataPriceForecastDate();
        if (response && response.latest_date) {
          setMaxDate(response.latest_date);
        }
      } catch (error) {
        console.error("Error fetching latest date:", error);
        // Keep the default maxDate if API call fails
      }
    };
    fetchLatestDate();
  }, []);

  return (
    <div className="header">
      <div className="flex items-center justify-start gap-x-2 logo-section" style={{width: "420px"}}>
       <Logo height={"18px"} width={"70px"}  />
      </div>
      <div className="gas-tabs title-section">
        <h1 className="header-title" style={{color: COLOR_CODES.secondary, fontSize: "18px", fontWeight: "600"}}>
          Power Market Analytics
        </h1>
      </div>
      <div className="flex items-center gap-x-5 justify-end controls-section">
        <div className="desktop-date-picker">
          <DynamicDatePicker
            defaultDates={dates}
            maxDate={maxDate}
            minDate={new Date('2024-01-01').toISOString().split('T')[0]}
            setDate={(dateArray) => {
              if (dateArray && dateArray.length > 0) {
                const selectedDates = dateArray[0];
                console.log('Selected dates:', selectedDates);
                setDates(selectedDates);
              }
            }}
          />
        </div>
        <button
          className="logout-btn flex items-center gap-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
          onClick={() => {
            setLoggedIn(false);
            localStorage.clear();
            window.location.href = "/login";
          }}
          title="Logout"
        >
          <LogOutIcon width={18} height={18} fill={COLOR_CODES.secondary} />
          <span className="logout-text text-sm font-medium" style={{color: '#9F9F9F'}}>
            Logout
          </span>
        </button>
      </div>
    </div>
  );
}
